import { ContactItemDto, ContactSearchRequestDto } from '@/api/generated';
import {
  contactStatusOptionsTranslation,
  ContactStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type ContactsTranslation = {
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<ContactItemDto, 'contactId'>, string>;
    details: {
      companyPosition: string;
      note: string;
      open: string;
    };
    head: Record<keyof ContactSearchRequestDto, string>;
    quickFilters: {
      inactive: string;
      mine: string;
      noContact30: string;
      noContact30Tooltip: string;
      noContact90: string;
      noContact90Tooltip: string;
      withoutCustomer: string;
    };
    row: {
      statusOptions: ContactStatusOptionsTranslation;
    };
  };
};

export const contactsTranslation: ContactsTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      contactOwnerId: 'Opiekun',
      customer: 'Klient',
      firstName: 'Imię',
      lastContactedAt: 'Ostatni kontakt',
      lastName: 'Nazwisko',
      name: 'Nazwa',
      ownerId: 'Utworzony przez',
      status: 'Status',
    },
    details: {
      companyPosition: 'Stanowisko',
      note: 'Notatka',
      open: 'Otwórz kontakt',
    },
    head: {
      customerFullTextSearchInput: 'Szukaj klienta',
      fullTextSearchInput: 'Szukaj',
      isAlreadyInCustomer: 'Przypisany do klienta',
      isAlreadyInSupplier: 'Przypisany do dostawcy',
      lastContactedFrom: 'Ostatni kontakt od',
      lastContactedTo: 'Ostatni kontakt przed',
      ownerIds: 'Opiekunowie',
      status: 'Status',
    },
    quickFilters: {
      inactive: 'Nieaktywne',
      mine: 'Tylko moje',
      noContact30: 'Bez kontaktu 30+ dni',
      noContact30Tooltip:
        'Ostatni proces z tym kontaktem rozpoczęto ponad 30 dni temu (albo nigdy)',
      noContact90: 'Bez kontaktu 90+ dni',
      noContact90Tooltip:
        'Ostatni proces z tym kontaktem rozpoczęto ponad 90 dni temu (albo nigdy)',
      withoutCustomer: 'Bez klienta',
    },
    row: {
      statusOptions: contactStatusOptionsTranslation,
    },
  },
};
